import React from 'react';
import { useClockTick } from '../../contexts/ClockTickContext.jsx';

// The IN timecode, shared by the Standard table and the Modern spine so the
// "Relative times" setting reads the same in both. `relative` shows a live
// countdown ("in 02:38", or "-00:12" once overdue) instead of the wall clock.
// Callers decide which rows are relative — a cue already taken keeps its clock
// time, since a countdown to something in the past says nothing.

function pad2(n) { return String(n).padStart(2, '0'); }

function formatClock(date) {
  return `${pad2(date.getHours())}:${pad2(date.getMinutes())}:${pad2(date.getSeconds())}`;
}

// MM:SS under an hour; beyond that "1h02" — seconds are noise that far out, and
// it keeps the text inside the IN column's width.
function formatOffset(seconds) {
  const h = Math.floor(seconds / 3600), m = Math.floor((seconds % 3600) / 60), s = seconds % 60;
  return h > 0 ? `${h}h${pad2(m)}` : `${pad2(m)}:${pad2(s)}`;
}

// Only countdown cells subscribe to the shared tick; wall-clock cells are static.
const Countdown = React.memo(function Countdown({ inTime, className, style }) {
  useClockTick();
  const diff = Math.round((inTime.getTime() - Date.now()) / 1000);
  const body = formatOffset(Math.abs(diff));
  return <span className={className} style={style}>{diff >= 0 ? `in ${body}` : `-${body}`}</span>;
});

export default function InTime({ inTime, relative, className, style }) {
  if (!inTime) return <span className={className} style={style}>--:--:--</span>;
  if (!relative) return <span className={className} style={style}>{formatClock(inTime)}</span>;
  return <Countdown inTime={inTime} className={className} style={style} />;
}
